/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import Swal from "sweetalert2";
import * as Icons from "heroicons-react";
import { useEffect, useState } from "react";
import { Button, Form, Table } from "react-bootstrap";
import { Toaster } from "react-hot-toast";
import SelectSupplier from "../Common/CustomSelect/SelectSupplier";
import WareHouseDWPurchase from "../Common/CustomSelect/WareHouseDWPurchase";
import Header from "../Common/Header/Header";
import SideBar from "../Common/SideBar/SideBar";
import usePurchase from "../Hooks/usePurchase";
import { signInUser } from "../Utility/Auth";
import { notify } from "../Utility/Notify";
import "./Purchase.css";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  resetPurchase,
  selectCalculation,
  selectDiscount,
  selectNote,
  selectProducts,
  selectShipping,
  selectStatus,
  selectSupplier,
  selectTax,
  selectWareHouse,
} from "../../features/purchaseSlice";
import {
  useAddPurchaseMutation,
  usePurchasesCountQuery,
} from "../../services/purchasApi";
import { useSupplierPurchaseQuery } from "../../services/supplierApi";
import { useWarehouseQuery } from "../../services/warehouseApi";
import CsvPurchaseProduct from "../Common/CsvImporter/CsvPurchaseProduct";
import LoadingModal from "../Common/Modal/LoadingModal";
import PackageModal from "../Common/Modal/PackageModal";
import { total } from "../Utility/PurchaseCalculations";
import { apiUniqueErrHandle } from "../Utility/Utility";
import PurchaseCart from "./parts/PurchaseCart";
import SupplierProduct from "./parts/SupplierProduct";

const PurchaseCreate = () => {
  const lang = useSelector((state) => state.languageReducer);

  const purchaseData = useSelector((state) => state.purchaseReducer);
  const BASE_URL =
    process.env.REACT_APP_API_URL || "http://localhost:5001/api/";
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [addPurchase] = useAddPurchaseMutation();
  const [supplierId, setSupplierId] = useState("");

  const [csvData, setCsvData] = useState([]);
  const [productList, setProductList] = useState([]);
  const [isTaxManual, setIsTaxManual] = useState(false);
  const [filteredProduct, setFilteredProduct] = useState([]);
  const [wh, setWh] = useState("");
  const { purchase, setPurchase } = usePurchase();
  const [supplierProducts, setSupplierProducts] = useState([]);
  const [whName, setWhName] = useState("Warehouse");
  // const [aamarId, setAamarId] = useState("");
  const [onShow, setOnShow] = useState(false);
  const handleClose = () => setOnShow(false);
  const auth = signInUser();
  const [modalVisible, setModalVisible] = useState(false);
  const closeModal = () => setModalVisible(false);

  // const { data, isSuccess, refetch, isFetching } = useSupplierQuery(supplierId);
  const { data, isSuccess, refetch } = useSupplierPurchaseQuery(supplierId, {
    skip: !supplierId,
  });

  console.log("SUPPLIER DATA", data);

  const { data: warehouseData, refetch: whRefetch } = useWarehouseQuery(
    auth?.warehouse,
    { skip: !auth?.warehouse }
  );
  const { data: countData } = usePurchasesCountQuery(auth?.aamarId, {
    skip: !auth?.aamarId,
  });

  useEffect(() => {
    if (auth?.warehouse && !wh) {
      setWh(auth?.warehouse);
      dispatch(selectWareHouse(auth?.warehouse));
    }
  }, [auth?.warehouse]);

  useEffect(() => {
    if (warehouseData) {
      setWhName(warehouseData?.name);
    }
  }, [warehouseData]);

  useEffect(() => {
    if (!supplierId) {
      setSupplierProducts([]);
      setFilteredProduct([]);
      dispatch(selectSupplier(""));
      dispatch(selectProducts([]));
      return;
    }
    setOnShow(false);
    if (data) {
      setSupplierProducts(data?.products || []);
      dispatch(selectSupplier(data?._id));
      dispatch(selectProducts([]));
      setPurchase(data);
    }
  }, [supplierId, isSuccess, data]);

  useEffect(() => {
    if (supplierId) {
      refetch();
    }
  }, [supplierId]);


  useEffect(() => {
    // ORDER SELECTED PRODUCT
    // console.log(purchaseData?.products);
    let orderdList = purchaseData?.products
      .slice()
      .sort((a, b) => a.order - b.order);
    // const { totalTax, total1 } = total(purchaseData?.products);

    // // SELECT CAL TOTAL
    // SELECT USER
    const { totalTax, total1 } = total(purchaseData?.products);

    // SELECT CAL TOTAL
    dispatch(
      selectCalculation({
        total: total1,
        tax: isTaxManual ? (Number(purchaseData?.tax) || 0) : totalTax,
      })
    );
    // setCalcTotal(totalcal);
    setProductList(orderdList);
    // dispatch(
    //   selectCalculation(productList)
    // );
  }, [purchaseData?.products]);

  useEffect(() => {
    if (supplierProducts?.length > 0) {
      setFilteredProduct(supplierProducts);
    } else {
      setFilteredProduct([]);
    }
  }, [supplierProducts, purchaseData]);

  const handleImportButton = async () => {
    if (!csvData || csvData.length === 0) {
      notify("There is no products to import", "error");
      return;
    }

    setOnShow(true);
    try {
      const importedProducts = [];
      const notFoundCodes = [];

      for (let i = 0; i < csvData.length; i++) {
        const pro = csvData[i];
        const code = pro?.article_code ? String(pro.article_code).trim() : "";
        if (!code) continue;

        try {
          const details = await axios(
            `${BASE_URL}product/pro-details/${encodeURIComponent(code)}`
          );
          const data = details?.data;

          if (details?.status === 200 && data && data?._id) {
            const activePrice =
              data?.priceList?.find((p) => p?.status === "active") ||
              data?.priceList?.[0] ||
              {};
            const tpVal =
              activePrice?.tp !== undefined && Number(activePrice.tp) >= 0
                ? Number(activePrice.tp)
                : 0;

            const targetUnit =
              typeof data?.unit === "object" && data?.unit?.name
                ? data.unit.name
                : data?.unit || "pcs";

            importedProducts.push({
              id: data._id,
              article_code: data.article_code || code,
              priceId: activePrice?._id || data._id,
              tp: tpVal,
              name: data.name,
              qty: Number(pro?.qty) > 0 ? Number(pro.qty) : 1,
              tax: 0,
              discount: 0,
              unit: targetUnit,
              aamarId: auth?.aamarId,
              warehouse: purchaseData?.warehouse || wh || auth?.warehouse,
              order: pro?.order
                ? Number(pro.order)
                : (purchaseData?.products?.length || 0) + importedProducts.length + 1,
            });
          } else {
            notFoundCodes.push(code);
          }
        } catch (itemErr) {
          console.error(`Error importing product ${code}:`, itemErr);
          notFoundCodes.push(code);
        }
      }

      if (importedProducts.length > 0) {
        const existingProducts = purchaseData?.products || [];
        const existingMap = new Map();
        existingProducts.forEach((p) => {
          existingMap.set(String(p.article_code || p.id), { ...p });
        });

        for (const item of importedProducts) {
          const key = String(item.article_code || item.id);
          if (existingMap.has(key)) {
            const existing = existingMap.get(key);
            existingMap.set(key, {
              ...existing,
              qty: Number(existing.qty || 0) + Number(item.qty || 1),
            });
          } else {
            existingMap.set(key, {
              ...item,
              order: existingMap.size + 1,
            });
          }
        }

        const mergedProducts = Array.from(existingMap.values());
        dispatch(selectProducts(mergedProducts));
        notify(`${importedProducts.length} product(s) imported successfully!`, "success");
      }

      if (notFoundCodes.length > 0) {
        if (notFoundCodes.length <= 4) {
          notify(`Product(s) not found in store: ${notFoundCodes.join(", ")}`, "error");
        } else {
          notify(
            `${notFoundCodes.length} product(s) not found in store (e.g. ${notFoundCodes.slice(0, 3).join(", ")}...)`,
            "error"
          );
        }
      }
    } catch (err) {
      console.error("Import failed:", err);
      notify(err?.message || "Import failed", "error");
    } finally {
      setOnShow(false);
    }
  };
  const localStorageAddFromCart = (items) => {
    const priceList = items?.id?.priceList || [];
    const activePriceList = priceList?.filter((pr) => pr?.status === "active");
    const effectivePriceList =
      activePriceList && activePriceList.length > 0
        ? activePriceList
        : priceList;

    const maxDate = effectivePriceList?.reduce((max, item) => {
      const date = new Date(item?.updatedAt || item?.createdAt || 0);
      return date > max ? date : max;
    }, new Date("1900-01-01T00:00:00.000Z"));

    const latestPrice =
      effectivePriceList?.find(
        (price) =>
          new Date(price?.updatedAt || price?.createdAt || 0).getTime() ===
          maxDate.getTime()
      ) ||
      effectivePriceList?.[0] ||
      {};

    const targetUnit =
      typeof items?.unit === "object" && items?.unit?.name
        ? items.unit.name
        : items?.unit || "pcs";
    const targetWarehouse = purchaseData?.warehouse || wh || auth?.warehouse;
    const targetPrice =
      latestPrice?.tp !== undefined ? parseFloat(latestPrice.tp) : 0;
    const targetPriceId = latestPrice?._id || items?.id?._id;

    let list = [];
    if (purchaseData?.products && purchaseData.products.length > 0) {
      const matched = purchaseData.products.find(
        (pro) => pro?.id === items?.id?._id
      );
      const rest = purchaseData?.products?.filter(
        (pro) => pro?.id !== items?.id?._id
      );

      if (matched) {
        notify("Product is already added", "error");
        return;
      } else {
        notify("Product is added", "success");
        list = [
          ...rest,
          {
            id: items?.id?._id,
            article_code: items?.id?.article_code || items?.article_code,
            priceId: targetPriceId,
            qty: 1,
            tp: targetPrice,
            tax: 0,
            discount: 0,
            unit: targetUnit,
            aamarId: auth?.aamarId,
            warehouse: targetWarehouse,
            name: items?.name,
            order: purchaseData?.products?.length + 1,
          },
        ];
      }
    } else {
      notify("Product is added", "success");
      list = [
        {
          id: items?.id?._id,
          article_code: items?.id?.article_code || items?.article_code,
          priceId: targetPriceId,
          qty: 1,
          tp: targetPrice,
          tax: 0,
          discount: 0,
          unit: targetUnit,
          aamarId: auth?.aamarId,
          warehouse: targetWarehouse,
          name: items?.name,
          order: 1,
        },
      ];
    }
    dispatch(selectProducts(list));
  };

  const handleSearch = (q) => {
    if (q && q.trim().length > 0) {
      const term = q.trim().toLowerCase();
      const filtered = supplierProducts?.filter((entry) => {
        const nameMatch = entry?.name?.toLowerCase().includes(term);
        const codeMatch = entry?.article_code?.toLowerCase().includes(term);
        const eanMatch = entry?.ean?.toLowerCase().includes(term);
        return nameMatch || codeMatch || eanMatch;
      });
      setFilteredProduct(filtered);
    } else {
      setFilteredProduct(supplierProducts || []);
    }
  };

  const handleBillSubmit = async () => {
    //@ts-ignore
    if (countData >= auth?.package?.purchaseLimited) {
      setModalVisible(true);
      return;
    } else {
      if (!purchaseData?.products || purchaseData?.products?.length < 1) {
        notify("Please add product to create purchase", "error");
        return;
      }

      const currentSupplier = purchaseData?.supplier || supplierId;
      if (!currentSupplier) {
        notify("Please select a supplier", "error");
        return;
      }

      const currentWarehouse = purchaseData?.warehouse || wh || auth?.warehouse;
      if (!currentWarehouse) {
        notify("Please select a warehouse", "error");
        return;
      }

      setOnShow(true);
      try {
        const result = await Swal.fire({
          title: "Are you Sure?",
          text: "Create this Purchase?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, create it!",
        });

        if (result.isConfirmed) {
          const payload = {
            ...purchaseData,
            supplier: currentSupplier,
            warehouse: currentWarehouse,
            aamarId: purchaseData?.aamarId || auth?.aamarId,
            userId: purchaseData?.userId || auth?.id || auth?._id,
          };
          const response = await addPurchase(payload);
          if (response) {
            if (response?.error) {
              apiUniqueErrHandle(response);
            } else {
              notify("Purchase create is successful", "success");
              dispatch(resetPurchase());
              setIsTaxManual(false);
              setPurchase({});
              navigate("/purchase");
            }
          }
        } else {
          notify("Cancel create purchase", "error");
        }
      } catch (err) {
        console.log(err);
      } finally {
        setOnShow(false);
      }
    }
  };

  const emptyCart = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Refresh Cart! Start New Purchase?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Reset it!",
    });

    if (result.isConfirmed) {
      dispatch(selectProducts([]));
      setIsTaxManual(false);
    } else {
      // console.log("Refresh Operation Cancelled by POSER");
    }
  };
  const handleOnchangeWareHouse = (e) => {
    setWh(e.option);
    dispatch(selectWareHouse(e?.option));
  };
  const handleVendorChange = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setSupplierId(selectedOption.value); // Update supplierId with the selected value
      setOnShow(true); // Trigger any additional action
    } else {
      setSupplierId(""); // Reset if no option is selected
    }
  };
  const removeFromCart = (code) => {
    const rest = purchaseData?.products?.filter(
      (pro) => pro.article_code !== code
    );
    notify("Product is removed", "error");
    // console.log(code);
    dispatch(selectProducts(rest));
  };
  const addQuantities = (id) => {
    if (purchaseData?.products) {
      let list = [];
      const item = purchaseData?.products?.find(
        (item) => item?.article_code === id
      );
      const restItem = purchaseData?.products?.filter(
        (item) => item?.article_code !== id
      );

      if (item) {
        list = [...restItem, { ...item, qty: parseFloat(item.qty) + 1 }];
      } else {
        list = [...restItem];
      }
      dispatch(selectProducts(list));
    }
  };
  const removeQuantities = (id) => {
    if (purchaseData.products) {
      let list = [];
      const item = purchaseData.products.find(
        (item) => item.article_code === id
      );
      const restItem = purchaseData?.products?.filter(
        (item) => item.article_code !== id
      );

      if (item) {
        list = [...restItem, { ...item, qty: parseFloat(item.qty) - 1 }];
      } else {
        list = [...restItem];
      }
      dispatch(selectProducts(list));
    }
  };
  const handleCustomQty = (e, id) => {
    let list = [];
    const customQty = e.target.value !== "" ? e.target.value : 0;
    // console.log(customQty, id);
    // const cartItems = getStoredCart();
    const item = purchaseData?.products?.find(
      (item) => item?.article_code === id
    );
    if (item) {
      let restItem = purchaseData?.products?.filter(
        (item) => item?.article_code !== id
      );
      if (customQty >= 0) {
        // item.qty = customQty;
        list = [...restItem, { ...item, qty: customQty }];
        dispatch(selectProducts(list));
      }
    }
  };
  const handleCustomTp = (e, id) => {
    let list = [];
    const tp = e.target.value !== "" ? e.target.value : 0;
    // console.log("TP", tp, id);
    const item = purchaseData?.products?.find(
      (item) => item?.article_code === id
    );
    if (item) {
      let restItem = purchaseData?.products?.filter(
        (item) => item?.article_code !== id
      );
      if (tp >= 0) {
        // item.qty = customQty;
        list = [...restItem, { ...item, tp: tp }];
        dispatch(selectProducts(list));
      }
    }
  };
  return (
    <div>
      <div className="container-fluid">
        <div className="row mb-5 pb-5">
          <div className="col-lg-2 mb-3">
            <SideBar />
          </div>
          <div className="col-lg-10">
            <Header title={lang?.createNewPurchase} />

            <Form className="pt-3" action="javascript:void(0);">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <Form.Group controlId="warehouse">
                    <Form.Label>Warehouse</Form.Label>
                    {auth?.type !== "admin" ? (
                      <div>{whName}</div>
                    ) : (
                      <WareHouseDWPurchase
                        handleOnChange={handleOnchangeWareHouse}
                        wh={wh}
                      />
                    )}
                  </Form.Group>
                </div>
                <div className="col-md-6 mb-3">
                  <Form.Group>
                    <Form.Label>Supplier</Form.Label>
                    <SelectSupplier
                      selected={{ value: supplierId }} // Pass current selected supplier
                      handleOnchange={handleVendorChange} // Pass handler function
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mb-3">
                  <Form.Group>
                    <Form.Label>Purchase Status</Form.Label>
                    <Form.Select
                      onChange={(e) => dispatch(selectStatus(e.target.value))}
                    >
                      <option selected value="Pending">
                        Pending
                      </option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-8 mb-3 ">
                  <CsvPurchaseProduct
                    title="Supplier Product"
                    setCsvData={setCsvData}
                    handleImportButton={handleImportButton}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-lg-5 mb-3">
                  <div className="card">
                    <div className="card-header">
                      Supplier Products List
                      <input
                        className="form-control form-control-md mt-2"
                        type="text"
                        placeholder="Search Product"
                        onChange={(e) => handleSearch(e.target.value)}
                      />
                    </div>
                    <div
                      style={{
                        overflowY: "scroll",
                        display: "block",
                        maxHeight: "220px",
                      }}
                    >
                      <Table className="mt-3 table-responsive-sm">
                        <thead>
                          <tr>
                            <th className="ps-2">Code</th>
                            <th className="ps-4">Name</th>
                            <th>Stock</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredProduct?.length > 0 ? (
                            <SupplierProduct
                              productList={filteredProduct}
                              localStorageAddFromCart={localStorageAddFromCart}
                            />
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center py-3 text-muted">
                                {supplierId
                                  ? "No products found for this supplier"
                                  : "Please select a supplier to view products"}
                              </td>
                            </tr>
                          )}
                        </tbody>

                      </Table>
                    </div>
                  </div>
                </div>
                <div className="col-lg-7 mb-3">
                  <div className="card">
                    <div className="card-header">Purchase Products List</div>
                    <div
                      className="px-1"
                      style={{
                        overflowY: "scroll",
                        display: "block",
                        maxHeight: "260px",
                      }}
                    >
                      <Table>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th className="ps-md-3">Name</th>
                            <th className="ps-md-5">Quantity</th>
                            <th className="ps-md-5">TP</th>
                            <th>Total</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          <PurchaseCart
                            purchaseCarts={productList}
                            removeFromCart={removeFromCart}
                            addQuantities={addQuantities}
                            removeQuantities={removeQuantities}
                            handleCustomQty={handleCustomQty}
                            handleCustomTp={handleCustomTp}
                          />
                        </tbody>
                      </Table>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4 mt-3">
                  <Form.Group>
                    <Form.Label>Tax</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      min="0"
                      className="tax"
                      placeholder="Tax"
                      value={purchaseData?.tax ?? ""}
                      onChange={(e) => {
                        setIsTaxManual(true);
                        dispatch(selectTax(e.target.value === "" ? 0 : parseFloat(e.target.value) || 0));
                      }}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mt-3">
                  <Form.Group>
                    <Form.Label>Discount</Form.Label>
                    <Form.Control
                      type="number"
                      className="discount"
                      placeholder="Discount"
                      onChange={(e) => dispatch(selectDiscount(e.target.value))}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-4 mt-3">
                  <Form.Group>
                    <Form.Label>Shipping Cost</Form.Label>
                    <Form.Control
                      onChange={(e) => dispatch(selectShipping(e.target.value))}
                      type="number"
                      className="shipping"
                      placeholder="Shipping Cost"
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12 mb-3">
                  <Form.Group>
                    <Form.Label>Note</Form.Label>
                    <textarea
                      className="form-control"
                      placeholder="Note"
                      onChange={(e) => dispatch(selectNote(e.target.value))}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="table-responsive mt-3">
                <Table className="table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Items: {purchaseData?.totalItem}</th>
                      <th>Total Tax: {Number(purchaseData.tax || 0).toFixed(2)}</th>
                      <th>Order Total: {purchaseData.total?.toFixed(2)}</th>
                      <th>Order Discount: {purchaseData.discount}</th>
                      <th>Shipping Cost: {purchaseData.shipping_cost}</th>
                      <th>
                        Grand Total:{" "}
                        {(
                          parseFloat(purchaseData?.tax || 0) +
                          parseFloat(purchaseData?.total || 0) +
                          parseFloat(purchaseData?.shipping_cost || 0) -
                          parseFloat(purchaseData?.discount || 0)
                        ).toFixed(2)}
                      </th>

                    </tr>
                  </thead>
                </Table>
              </div>

              <div className="d-flex justify-content-end">
                <Button
                  variant="dark"
                  className="my-2 mx-2"
                  type="button"
                  onClick={emptyCart}
                >
                  Reset Cart
                </Button>
                <Button
                  variant="dark"
                  onClick={handleBillSubmit}
                  className="my-2"
                  type="button"
                >
                  <Icons.SaveOutline size={20} /> Submit
                </Button>
              </div>
            </Form>

            <LoadingModal
              onShow={onShow}
              title="Please Wait.."
              handleClose={handleClose}
            />
            <Toaster position="bottom-right" />
          </div>
        </div>
      </div>
      {/* Package Info Modal */}
      <PackageModal show={modalVisible} handleClose={closeModal} />{" "}
    </div>
  );
};

export default PurchaseCreate;
